<template>
  <billing-report-panel
    report-key="transfer-professional"
    route="/reports/billing-transfer-professional"
    file-name="repasse-por-profissional.xlsx"
    period-label="Período do repasse"
    :columns="columns"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Profissional',
        'CRM e especialidade',
        'Origem',
        'Referência',
        'Convênio',
        'Itens',
        'Base de cálculo',
        'Repasse calculado',
        'Ajustes de glosa a descontar',
        'Ajustes de glosa a devolver',
        'Líquido a pagar',
        'Já pago',
        'Subtotal por profissional',
      ],
    };
  },
};
</script>
